"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _actionType = require("./actionType");

var initialState = {
  user: null,
  isLoggedIn: false,
  isLoggingIn: false,
  loginError: null,
  tokens: {},
  isRefreshing: false,
  isUserFetching: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionType.AUTH_LOGIN:
      return (0, _objectSpread2.default)({}, state, {
        isLoggedIn: false,
        isLoggingIn: true,
        loginError: null,
        isUserFetching: true
      });

    case _actionType.AUTH_LOGIN_SUCCESS:
      return (0, _objectSpread2.default)({}, state, {
        isLoggedIn: true,
        isLoggingIn: false,
        user: action.user,
        loginError: null,
        isUserFetching: false
      });

    case _actionType.AUTH_LOGIN_FAILURE:
      return (0, _objectSpread2.default)({}, state, {
        isLoggedIn: false,
        isLoggingIn: false,
        user: null,
        loginError: action.error,
        isUserFetching: false
      });

    case _actionType.SET_AUTH_TOKENS:
      return (0, _objectSpread2.default)({}, state, {
        isLoggedIn: true,
        tokens: (0, _objectSpread2.default)({}, state.tokens, action.tokens)
      });

    case _actionType.AUTH_LOGOUT:
      return (0, _objectSpread2.default)({}, state, {
        isLoggedIn: false,
        user: null,
        tokens: {}
      });

    case _actionType.AUTH_REFRESH_TOKEN:
      return (0, _objectSpread2.default)({}, state, {
        isRefreshing: true
      });

    case _actionType.AUTH_REFRESH_TOKEN_SUCCESS:
      return (0, _objectSpread2.default)({}, state, {
        isRefreshing: false,
        tokens: (0, _objectSpread2.default)({}, state.tokens, action.tokens)
      });

    case _actionType.AUTH_REFRESH_TOKEN_FAILURE:
      return (0, _objectSpread2.default)({}, state, {
        isRefreshing: false
      });

    case _actionType.FETCH_AUTH_USER_REQUEST:
      return (0, _objectSpread2.default)({}, state, {
        isUserFetching: true
      });

    case _actionType.FETCH_AUTH_USER_SUCCESS:
      return (0, _objectSpread2.default)({}, state, {
        user: action.user,
        isUserFetching: false
      });

    case _actionType.FETCH_AUTH_USER_FAILURE:
      return (0, _objectSpread2.default)({}, state, {
        isUserFetching: false
      });

    default:
      return state;
  }
};

exports.reducer = reducer;